/** mini-apps — EN source (114 keys). */
export const miniApps = {
  miniapps_close_button: "Close",
  miniapps_close_accessibility_label: "Close mini app",
  miniapps_error_load_failed: "Failed to load mini app",
  miniapps_error_title: "Error",
  miniapps_success_title: "Success",
  miniapps_cancel_button: "Cancel",
  miniapps_delete_button: "Delete",
  miniapps_try_again_button: "Try Again",
  miniapps_go_back_button: "Go Back",
  miniapps_loading: "Loading...",
  miniapps_demo_title: "Demo Mini App",
  miniapps_demo_description:
    "Test all bridge features including user info, storage, API calls, toasts, alerts, and more.",
  miniapps_demo_open_button: "Open Demo",
  miniapps_demo_open_full_button: "Open Demo Mini App",
  miniapps_demo_error_prefix: "Error: {error}",
  miniapps_demo_result_success: "Last result: Success",
  miniapps_demo_result_failed: "Last result: Failed",
  miniapps_demo_result_with_data: "Last result: {status} - {data}",
  miniapps_permission_request_title: "Permission Request",
  miniapps_permission_deny_button: "Deny",
  miniapps_permission_allow_button: "Allow",
  miniapps_permission_grant_fallback: "Grant {permission} permission",
  miniapps_permission_user_read_title: "Read Profile",
  miniapps_permission_user_read_description:
    "Access your profile information including name and photo",
  miniapps_permission_user_write_title: "Modify Profile",
  miniapps_permission_user_write_description:
    "Make changes to your profile information",
  miniapps_permission_api_read_title: "Read Data",
  miniapps_permission_api_read_description:
    "Access data from the Linqx platform",
  miniapps_permission_api_write_title: "Write Data",
  miniapps_permission_api_write_description:
    "Create or modify data on the Linqx platform",
  miniapps_permission_camera_title: "Camera",
  miniapps_permission_camera_description:
    "Take photos or record videos using your camera",
  miniapps_permission_files_title: "Files",
  miniapps_permission_files_description: "Access files from your device",
  miniapps_permission_notifications_title: "Notifications",
  miniapps_permission_notifications_description: "Send you push notifications",
  miniapps_permission_location_title: "Location",
  miniapps_permission_location_description: "Access your device location",
  miniapps_permission_storage_title: "Storage",
  miniapps_permission_storage_description: "Store data locally on your device",
  miniapps_permission_haptics_title: "Haptics",
  miniapps_permission_haptics_description: "Provide haptic feedback",
  miniapps_permission_contacts_title: "Contacts",
  miniapps_permission_contacts_description: "Access your contacts",
  miniapps_permission_default_label: "Default permission",
  miniapps_permission_optional_label: "Optional permission",
  miniapps_list_title: "Mini Apps",
  miniapps_list_loading: "Loading mini apps...",
  miniapps_list_error_title: "Failed to load mini apps",
  miniapps_list_create_button: "Create",
  miniapps_list_empty_title: "No Mini Apps Yet",
  miniapps_list_empty_description:
    "Create your first mini app or wait for the administrator to add some.",
  miniapps_list_create_mini_app_button: "Create Mini App",
  miniapps_list_available_apps_title: "Available Apps ({count})",
  miniapps_list_no_description: "No description",
  miniapps_list_info_text:
    "Mini apps are lightweight web applications that run inside Linqx. They can access your profile (with permission) and integrate with platform features.",
  miniapps_details_loading: "Loading app details...",
  miniapps_details_error_title: "Failed to load app",
  miniapps_details_by_developer: "by {developer}",
  miniapps_details_status_active: "Active",
  miniapps_details_status_system: "System",
  miniapps_details_open_app_button: "Open App",
  miniapps_details_app_info_title: "App Information",
  miniapps_details_version_label: "Version",
  miniapps_details_app_id_label: "App ID",
  miniapps_details_added_label: "Added",
  miniapps_details_system_app_label: "System App",
  miniapps_details_system_app_description:
    "Built-in app managed by Linqx. Permissions are set automatically.",
  miniapps_details_permissions_title: "Permissions",
  miniapps_details_no_permissions:
    "This app doesn't require any special permissions.",
  miniapps_details_danger_zone_title: "Danger Zone",
  miniapps_details_delete_app_button: "Delete App",
  miniapps_details_cannot_delete_title: "Cannot Delete",
  miniapps_details_cannot_delete_message: "System apps cannot be deleted.",
  miniapps_details_delete_confirm_title: "Delete Mini App",
  miniapps_details_delete_confirm_message:
    'Are you sure you want to delete "{appName}"? This action cannot be undone.',
  miniapps_details_error_load: "Failed to load app details",
  miniapps_ok_button: "OK",
  miniapps_details_permission_update_error: "Failed to update permission",
  miniapps_details_delete_error: "Failed to delete mini app",
  miniapps_create_title: "Create Mini App",
  miniapps_create_subtitle: "Configure your new mini app",
  miniapps_create_basic_info_title: "Basic Information",
  miniapps_create_app_id_label: "App ID",
  miniapps_create_app_id_placeholder: "com.example.myapp",
  miniapps_create_app_id_error_required: "App ID is required",
  miniapps_create_app_id_error_format:
    "App ID must start with a letter and contain only lowercase letters, numbers, dots, and hyphens",
  miniapps_create_name_label: "Name",
  miniapps_create_name_placeholder: "My Awesome App",
  miniapps_create_name_error_required: "Name is required",
  miniapps_create_description_label: "Description",
  miniapps_create_description_placeholder: "Describe what your app does...",
  miniapps_create_url_label: "URL",
  miniapps_create_url_placeholder: "https://example.com/app",
  miniapps_create_url_error_required: "URL is required",
  miniapps_create_url_error_format:
    "URL must start with http://, https://, or data:",
  miniapps_create_icon_label: "App Icon",
  miniapps_create_icon_add: "Add",
  miniapps_create_icon_hint:
    "Tap to upload a square icon (recommended 512x512)",
  miniapps_create_developer_label: "Developer",
  miniapps_create_developer_placeholder: "Your name or company",
  miniapps_create_version_label: "Version",
  miniapps_create_version_placeholder: "1.0.0",
  miniapps_create_version_error_required: "Version is required",
  miniapps_create_permissions_title: "Permissions",
  miniapps_create_permissions_description:
    "Select which permissions your app needs. Default permissions are granted automatically.",
  miniapps_create_enable_label: "Enable",
  miniapps_create_default_label: "Default",
  miniapps_create_cancel_button: "Cancel",
  miniapps_create_creating: "Creating...",
  miniapps_create_submit_button: "Create App",
  miniapps_create_success_title: "Success",
  miniapps_create_success_message: "Mini app created successfully",
  miniapps_create_error: "Failed to create mini app",
};
